import { jump, getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import type { DataType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';

const baseLink = '/channel-service/activity/collection-pool-list';

const data = getDataThrowToMicroapp({ baseLink });

const _data: DataType = {
  ...data,
  // 收品池列表
  jumpCollection(query, type) {
    jump(baseLink + '/pools/roomlist' + query, type);
  },
  // 收品池列表
  jumpPoolList(query, type) {
    jump(baseLink + '/pools/roomlist' + query, type);
  },
  jumpEffectData(query, type) {
    jump(baseLink + '/pools/effectdata' + query, type);
  },
};

export default _data;
